import { gql } from "@apollo/client";

export const ACTIVATE_USER_IN_REGION = gql`
  mutation ActivateUserInRegion {
    activateUserInRegion {
      user {
        mrn
      }
    }
  }
`;
